import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowRight, Star } from 'lucide-react';

interface BlogHeroProps {
  selectedLocation: string;
}

const BlogHero: React.FC<BlogHeroProps> = ({ selectedLocation }) => {
  return (
    <section 
      className="relative bg-gradient-to-br from-brand-charcoal-gray via-black to-brand-charcoal-gray text-white py-16 md:py-20 overflow-hidden"
      style={{
        backgroundImage: `url('/lovable-uploads/fe5778ac-5f72-4e1c-8196-64340f2ec0b8.png')`,
        backgroundSize: '200px 200px',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-brand-charcoal-gray/90"></div>
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-brand-trophy-gold/10 to-transparent"></div>
      <div className="relative container mx-auto px-4 z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <Badge variant="outline" className="border-brand-trophy-gold/50 text-brand-trophy-gold bg-brand-trophy-gold/10 backdrop-blur-sm">
              <Star className="h-3 w-3 mr-1" />
              Expert Insights
            </Badge>
            <Badge variant="outline" className="border-white/30 text-white/90 bg-white/10 backdrop-blur-sm">
              Latest Updates
            </Badge>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-brand-trophy-gold drop-shadow-lg">
            Roofing Tips & 
            <span className="block">Expert Insights</span>
          </h2>
          <p className="text-xl md:text-2xl mb-8 text-white max-w-3xl mx-auto drop-shadow-md">
            Stay informed with professional advice, industry trends, and essential information about roofing maintenance and improvements in <span className="text-brand-trophy-gold font-semibold">{selectedLocation.charAt(0).toUpperCase() + selectedLocation.slice(1)}</span>.
          </p>
          <div className="flex justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-brand-safety-orange hover:bg-brand-safety-orange/90 text-white font-semibold px-8 py-4 text-lg shadow-xl">
                Get Free Estimate
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;
